export default [
  { id: 'NONE', label: '无', i18n: 'cswsa1' },
  { id: 'RANDOM', label: '随机', i18n: 'cswsa2' },
  { id: 'BAI_YE_CHUANG', label: '百叶窗', i18n: 'cswsa3' },
  { id: 'CA_CHU', label: '擦除', i18n: 'cswsa4' },
  { id: 'HE_ZHUANG', label: '盒状', i18n: 'cswsa5' },
  { id: 'JIE_TI', label: '阶梯', i18n: 'cswsa6' },
  { id: 'LING_XING', label: '菱形', i18n: 'cswsa7' },
  { id: 'LUN_ZI', label: '轮子', i18n: 'cswsa8' },
  { id: 'PI_LIE', label: '劈裂', i18n: 'cswsa9' },
  { id: 'QIE_RU', label: '切入', i18n: 'cswsa10' },
  { id: 'QI_PAN', label: '棋盘', i18n: 'cswsa11' },
  { id: 'SHAN_XIANG_ZHAN_KAI', label: '扇形展开', i18n: 'cswsa12' },
  { id: 'SUI_JI_XIOAN_TIAO', label: '十字线条', i18n: 'cswsa13' },
  { id: 'XIANG_NEI_RONG_JIE', label: '向内溶解', i18n: 'cswsa14' },
  { id: 'YUAN_XING_KUO_ZHAN', label: '圆形扩展', i18n: 'cswsa15' }
];